<template>
  <section class="space-audit">
    <div class="header-actions">
      <div class="go-back" @click="goback">返回></div>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </div>
    <el-divider></el-divider>
    <div class="gap"></div>
    <el-form :model="formData" label-width="120px">
      <el-form-item label="开始日期">
        <el-date-picker
          v-model="formData.sharingStart"
          type="date"
          placeholder="选择开始日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="结束日期">
        <el-date-picker
          v-model="formData.sharingEnd"
          type="date"
          placeholder="选择结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="可租日期">
        <el-radio-group v-model="formData.shareTimeType">
          <el-radio label="1">每天</el-radio>
          <el-radio label="2">限工作日</el-radio>
          <el-radio label="3">限非工作日</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="可租时段">
        <el-radio-group v-model="formData.rentalTime">
          <el-radio label="24h">24小时</el-radio>
          <el-radio label="partial">部分时间段</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="formData.rentalTime === 'partial'">
        <el-time-picker
          v-model="formData.shareBegTime"
          placeholder="开始时间"
          format="HH:mm"
          @change="handleTimeChange"
        >
        </el-time-picker>
        <span class="time-separator">至</span>
        <el-time-picker
          v-model="formData.shareEndTime"
          placeholder="结束时间"
          :format="endTimeFormat"
          @change="handleTimeChange"
        >
        </el-time-picker>
      </el-form-item>
    </el-form>
  </section>
</template>
<script>

import { shareSpaceDetail, shareSpaceAudit,  spacePublished } from "@/api/url";
import dayjs from "dayjs";
export default {
  data: function () {
    return {
      active: 0,
      processSteps: [ 
        {
          date: "",
          description: "提交申请",
          status: "application",
          auditStep: 0,
        },
        // {
        //   date: "",
        //   description: "物业审批",
        //   status: "property",
        //   auditStep: 1,
        //   isPassed: "",
        // },
        {
          date: "",
          description: "平台审批",
          status: "platform",
          auditStep: 2,
          isPassed: "",
        },
        {
          date: "",
          description: "结束",
          status: "success",
          auditStep: 3,
        },
      ],
      recordLine: [
        {
          title: "更新 Github 模板",
          date: "2024-01-09",
          content: "王小虎 提交于 2018/4/12 20:46",
        },
        {
          title: "更新 Github 模板",
          date: "2024-01-09",
          content: "王小虎 提交于 2018/4/12 20:46",
        },
      ],
      baseInfo: {
        name: "深圳木卫二科技有限公司",
        businessLicense: "SZ5598716453287",
        type: "个人",
        parkingName: "友谊天下停车场",
        city: "深圳",
        contactPerson: "MMM",
      },
      record: {},
      isShowAuditBtn: false,
      formData: {
        sharingStart: "",
        sharingEnd: "",
        shareTimeType: "everyday",
        rentalTime: "24h",
        shareBegTime: "",
        shareEndTime: "",
      },
      showNextDay: false,
    };
  },
  mounted() {
    this.record = JSON.parse(this.$route?.query?.space ?? "{}");
    const space={
    
      sharingStart: this.record.sharingStart,
      sharingEnd: this.record.sharingEnd,
      shareTimeType: this.record.shareTimeType+"",
      rentalTime: this.record.shareBegTime=="00:00" && this.record.shareEndTime=="00:00" ? "24h" : "partial",
      shareBegTime: dayjs(`${dayjs().format('YYYY-MM-DD')} ${this.record.shareBegTime}`),
      shareEndTime: dayjs(`${dayjs().format('YYYY-MM-DD')}${this.record.shareEndTime}`),
    }
  
    this.formData = {
      ...this.formData,
      ...space,
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    handleConfirm() {
      const {
        sharingStart,
        sharingEnd,
        shareTimeType,
        rentalTime,
        shareBegTime,
        shareEndTime,
      } = this.formData;
      const params = {
        sharingStart,
        sharingEnd,
        shareTimeType,
      };
      if (rentalTime === "partial"&& shareBegTime && shareEndTime) {
        params.shareBegTime = dayjs(shareBegTime).format("HH:mm");
        params.shareEndTime = dayjs(shareEndTime).format("HH:mm");  
      } else {
        params.shareBegTime = "00:00";
        params.shareEndTime = "00:00";
      }
      this.$putRequest(`${spacePublished()}/${this.record.id}`, {...params,id:this.record.id}).then(
        (res) => {
          console.log("设置成功", res);
          this.$message.success("设置已保存");
          this.goback();
        }
      );
    },

    
    handleAuditStatus(data) {
      switch (data.auditStatus) {
        case 0:
          return "审核通过";

        case 1:
          return "待审核";

        case 2:
          return "审核不通过";

        default:
          return "";
      }
    },
    handleTimeChange() {
      const startTime = this.formData.startTime;
      const endTime = this.formData.endTime;
      this.showNextDay = endTime < startTime;
    },
  },
  computed: {
    endTimeFormat() {
      if (!this.formData.shareBegTime || !this.formData.shareEndTime) {
        return "HH:mm";
      }
      return this.formData.shareEndTime < this.formData.shareBegTime
        ? "次日 HH:mm"
        : "HH:mm";
    },
  },
};
</script>
<style scoped>
.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.go-back {
  font-size: 16px;
  cursor: pointer;
  color: #409eff;
}
.space-audit {
  padding: 20px;
  overflow-y: auto;
  height: 100%;
  padding-bottom: 150px;
}
.gap {
  padding-bottom: 20px;
  box-sizing: border-box;
}
.time-separator {
  margin: 0 10px;
  color: #606266;
}
.next-day-text {
  margin-left: 10px;
  color: #409eff;
  font-size: 14px;
}
.el-time-picker {
  width: 180px;
}
.record ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;

  flex-wrap: wrap;
}
.record ul li {
  width: 50%;
  padding: 5px 0;
  box-sizing: border-box;
}
.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}
.record-title {
  font-size: 16px;
  font-weight: bold;
  color: #666;
}
.operate {
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0;
  left: 16%;
  background: white;
  padding-left: 18%;
  box-shadow: 0px -10px 20px #f3f3f3;
  padding-top: 20px;
  box-sizing: border-box;
}
.resolve-button {
  width: 300px;
  height: 60px;
  margin-right: 20px;
  font-size: 30px;
  letter-spacing: 4px;
}
.reject-button {
  width: 300px;
  height: 60px;
  font-size: 30px;
  letter-spacing: 4px;
}
:deep(.el-form-item__label) {
  line-height: 32px;
}
:deep(.el-form-item__content) {
  line-height: 32px;
}
</style>
<style>
.el-select {
  display: block;
}
</style>
